<template>
  <div id="tab-container">
    <b-tabs pills content-class="mt-3 text-center" align="center">
      <b-tab title="Kierowcy we flocie" active>
        <b-button variant="primary" class="float-right my-4" v-b-modal.add-emp
          >Dodaj kierowcę</b-button
        >
        <b-table
          v-if="!isLoading && returnDrivers"
          hover
          striped
          class="vehtable"
          :items="returnDrivers"
          :sort-by.sync="sortBy"
          :fields="fields"
          responsive
        >
          <template #cell(active)="row">
            <b-button
              size="sm"
              :variant="row.item.active ? 'success' : 'secondary'"
              @click="toggleDriver(row.item)"
              class="mr-1"
            >
              {{ row.item.active ? "Tak" : "Nie" }}
            </b-button>
          </template>
          <template #cell(onHold)="row">
            <b-button
              size="sm"
              :variant="row.item.onHold ? 'success' : 'secondary'"
              @click="toggleHold(row.item)"
              class="mr-1"
            >
              {{ row.item.onHold ? "Tak" : "Nie" }}
            </b-button>
          </template>
          <template #cell(edycja)="row">
            <b-button
              size="sm"
              variant="primary"
              @click="setEditEmp(row.item)"
              v-b-modal.edit-emp
              class="mr-1"
            >
              Edytuj
            </b-button>
            <b-button
              size="sm"
              variant="danger"
              @click="deleteEmp(row.item.id)"
              class="mr-1"
            >
              Usuń
            </b-button>
          </template>
        </b-table>
        <h5 v-if="!returnDrivers.length">
          Nikt z kierowców nie przesłał jeszcze grafiku - dlatego nie jest
          aktualnie wyświetlana lista. Kierowcy dodawani są automatyczne.
        </h5>
      </b-tab>
    </b-tabs>
    <new-emp />
    <edit-emp :emp="editData" />
  </div>
</template>

<script>
import NewEmp from "../components/modals/NewEmp.vue";
import EditEmp from "../components/modals/EditEmp.vue";
export default {
  components: {
    NewEmp,
    EditEmp,
  },
  data() {
    return {
      isLoading: false,
      sortBy: "fullName",
      fields: [
        {
          key: "fullName",
          label: "Imię i nazwisko",
          sortable: true,
        },
        {
          key: "phoneNumber",
          label: "Numer telefonu",
          sortable: true,
        },
        {
          key: "pinCode",
          label: "Kod PIN",
          sortable: true,
        },
        {
          key: "address",
          label: "Adres",
          sortable: true,
        },
        {
          key: "lastDay",
          label: "Ostatnia zmiana",
          sortable: true,
        },
        {
          key: "active",
          label: "Aktywny",
          sortable: true,
        },
        {
          key: "onHold",
          label: "Pauza",
          sortable: true,
        },
        {
          key: "onHoldStart",
          label: "Pauza od",
          sortable: true,
        },
        {
          key: "onHoldEnd",
          label: "Pauza do",
          sortable: true,
        },
        {
          key: "edycja",
          label: "Akcje",
        },
      ],
      editData: null,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.isLoading = true;
      await this.$store.dispatch("getDrivers");
      this.isLoading = false;
    },
    async deleteEmp(id) {
      await this.$store.dispatch("removeDriverList", id);
    },
    async toggleDriver(item) {
      this.$store.dispatch("toggleDriver", {
        active: !item.active,
        id: item.id,
      });
    },
    async toggleHold(item) {
      this.$store.dispatch("toggleDriverHold", {
        onHold: !item.onHold,
        id: item.id,
      });
      await this.$store.dispatch("getDrivers");
    },
    setEditEmp(item) {
      this.editData = item;
    },
  },
  computed: {
    returnDrivers() {
      return !this.isLoading && this.$store.getters["getDriverList"];
    },
  },
};
</script>

<style scoped>
#tab-container {
  width: 95%;
  background-color: #fff;
  border-radius: 20px;
  padding: 20px;
}
.vehtable {
  text-align: center;
}
</style>
